<tpm-textfield
  [icon]="'gpi-filled-search'"
  [formControl]="control"
  [placeholder]="filterLabel | translate"
></tpm-textfield>
